// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gravity-form-result_wrapper__8UkmQ"};